import { useState } from 'react'

export enum FormViews {
  edit = 'edit',
  view = 'view',
}

export function useEdition({ editable, initialView }: { editable: boolean; initialView: FormViews }) {
  const [view, setView] = useState(initialView)

  const showEditionButton = editable && view === FormViews.view
  const enableEdition = () => setView(FormViews.edit)
  const disableEdition = () => setView(FormViews.view)

  return {
    showEditionButton,
    enableEdition,
    disableEdition,
    view,
  }
}
